module.exports = __webpack_public_path__ + "static/media/email.ff16ccbf.svg";